import { Box, Flex, Heading, Switch, Text } from "@radix-ui/themes";
import { useDashboardStatsQuery } from "@/shared/api";
import { DashboardFilters } from "../lib/types";
import { useLocalStorage } from "react-use";
import { ComparisonDialog } from "./comparison-dialog";
import { PredictionLineBarChart } from "./prediction-line-bar-chart";
import { convertFiltersToQueryParams } from "../lib/filters-to-query-params";
import { CustomTooltip } from "./custom-tooltip";

type F1ScoreChartProps = {
  filters: DashboardFilters;
};

export function F1ScoreChart({ filters }: F1ScoreChartProps) {
  const [isBarChart, setIsBarChart] = useLocalStorage("is_bar_chart", false);

  const { data, isFetching } = useDashboardStatsQuery(
    convertFiltersToQueryParams(filters)
  );

  const labelToValueMap = {
    "Zone based F1 score": "zone_based_f1_score",
    "Pin based F1 score": "pin_based_f1_score",
  };

  const isChartClickable = (event: any) => {
    const payload = event.activePayload?.[0].payload;

    if (!payload) {
      return false;
    }

    const zoneBasedF1Score = payload.zone_based_f1_score;
    const pinBasedF1Score = payload.pin_based_f1_score;

    if (zoneBasedF1Score === null && pinBasedF1Score === null) {
      return false;
    }

    return true;
  };

  return (
    <Box className="relative z-20">
      <Flex gap="5" align="center">
        <Heading size="4">F1 Score Chart</Heading>
        <Flex gap="2">
          <Switch
            checked={isBarChart}
            onCheckedChange={setIsBarChart}
            size="1"
          />{" "}
          <Text
            size="1"
            weight="medium"
            className={!isBarChart ? "opacity-50" : ""}
          >
            Bar Chart
          </Text>
        </Flex>
        <div className="grow"></div>
        <ComparisonDialog filters={filters} />
      </Flex>

      <PredictionLineBarChart
        data={data}
        isFetching={isFetching}
        isBarChart={isBarChart}
        labelToValueMap={labelToValueMap}
        tooltipContent={<CustomTooltip />}
        isChartClickable={isChartClickable}
      />
    </Box>
  );
}
